var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C6.81886 0 5.17547 0.498516 3.77766 1.43251C2.37984 2.3665 1.29037 3.69402 0.647028 5.24719C0.00368295 6.80036 -0.164645 8.50943 0.163329 10.1583C0.491303 11.8071 1.30085 13.3217 2.4896 14.5104C3.67834 15.6992 5.1929 16.5087 6.84173 16.8367C8.49057 17.1646 10.1996 16.9963 11.7528 16.353C13.306 15.7096 14.6335 14.6202 15.5675 13.2223C16.5015 11.8245 17 10.1811 17 8.5C16.9973 6.24647 16.101 4.08601 14.5075 2.49253C12.914 0.899045 10.7535 0.00265855 8.5 0ZM8.5 15.4545C7.12452 15.4545 5.77993 15.0467 4.63626 14.2825C3.4926 13.5183 2.60121 12.4322 2.07484 11.1614C1.54847 9.89061 1.41074 8.49228 1.67909 7.14323C1.94743 5.79419 2.60979 4.555 3.5824 3.58239C4.55501 2.60978 5.79419 1.94743 7.14324 1.67908C8.49229 1.41074 9.89061 1.54846 11.1614 2.07484C12.4322 2.60121 13.5183 3.49259 14.2825 4.63626C15.0467 5.77993 15.4545 7.12452 15.4545 8.5C15.4525 10.3438 14.7191 12.1116 13.4153 13.4153C12.1116 14.7191 10.3438 15.4525 8.5 15.4545Z",
    fill: "url(#paint0_linear_1719_865)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27277 11.5914V7.72781C9.27277 7.52287 9.19136 7.32632 9.04644 7.1814C8.90153 7.03649 8.70498 6.95508 8.50004 6.95508H7.72732C7.52238 6.95508 7.32583 7.03649 7.18092 7.1814C7.036 7.32632 6.95459 7.52287 6.95459 7.72781C6.95459 7.93275 7.036 8.12929 7.18092 8.27421C7.32583 8.41912 7.52238 8.50053 7.72732 8.50053V12.3642C7.72732 12.5691 7.80873 12.7657 7.95364 12.9106C8.09856 13.0555 8.2951 13.1369 8.50004 13.1369H9.27277C9.47771 13.1369 9.67426 13.0555 9.81917 12.9106C9.96409 12.7657 10.0455 12.5691 10.0455 12.3642C10.0455 12.1592 9.96409 11.9627 9.81917 11.8178C9.67426 11.6729 9.47771 11.5914 9.27277 11.5914Z",
    fill: "url(#paint1_linear_1719_865)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 6.18217C8.92679 6.18217 9.27275 5.83621 9.27275 5.40945C9.27275 4.98268 8.92679 4.63672 8.50002 4.63672C8.07326 4.63672 7.72729 4.98268 7.72729 5.40945C7.72729 5.83621 8.07326 6.18217 8.50002 6.18217Z",
    fill: "url(#paint2_linear_1719_865)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1719_865",
    x1: -0.265813,
    y1: 18.1181,
    x2: 14.6594,
    y2: 1.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1719_865",
    x1: 0.503091,
    y1: 18.8203,
    x2: 15.4283,
    y2: 2.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1719_865",
    x1: -1.80507,
    y1: 16.716,
    x2: 13.1202,
    y2: 0.340355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420849,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494208,
    stopColor: "#2B4D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#2A6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6767"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseInfoIcon);
export default __webpack_public_path__ + "static/media/pulse-info-icon.e6550e7f5285fbd570b10cf099094905.svg";
export { ForwardRef as ReactComponent };